import React, { useState, useEffect } from "react";
import "./ToTopOverlay.css";

const ToTopOverlay = () => {
  const [showToTop, setShowToTop] = useState(false);

  useEffect(() => {
    const container = document.querySelector(".full-container");

    if (!container) return;

    const handleScroll = () => {
      if (container.scrollTop > 300) {
        setShowToTop(true);
      } else {
        setShowToTop(false);
      }
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    const container = document.querySelector(".full-container");
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    showToTop && (
      <div className="to-top-wrapper">
        <div className="to-top-overlay" onClick={scrollToTop}>
          ↑ Top
        </div>
      </div>
    )
  );
};

export default ToTopOverlay;
